import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import DocumentSectionLayout from './../../../layouts/DocumentSectionLayout';
import ClassementDocuments from './ClassementDocuments';

const DocumentsClassificationPage = () => {
    const navigate = useNavigate();

    return (
        <Container maxWidth="lg" sx={{ py: 4 }}>
            <DocumentSectionLayout
                title="Classement des documents"
                onBack={() => navigate('/dashboard/documents')}
            >
                <ClassementDocuments />
            </DocumentSectionLayout>
        </Container>
    );
};

export default DocumentsClassificationPage;
